module.exports = __webpack_public_path__ + "assets/img/video33.00771187.png";